// Native
import { useEffect, useState } from "react"
import { useNavigate } from "react-router"
import { Button, DialogBody, Stack, Text } from "@chakra-ui/react"

// Custom
import { Form, UI } from "components"
import { API, toaster } from "config"
import useUser from "hooks/useUser"

export default function Check({ onSuccess = () => {}, ...props }){

    const navigate = useNavigate()
    const user = useUser()
    const [ value, setValue ] = useState([])
    const [ code, setCode ] = useState()
    const [ loading, setLoading ] = useState(false)

    const handleConfigure = () => {
        navigate('/ajustes')
        props.onClose()
    }
    
    const handleSubmit = async () => {
        if(!code) return 
        setLoading(true)

        try{
            await API.post(`/me/security-code`, { security_code: code })
            toaster.create({ title: 'Código de segurança verificado.', type: 'success' })
            onSuccess(code)
            props.onClose()
        }catch(err){
            toaster.create({ title: 'O código de segurança é inválido. Tente novamente.', type: 'warning' })

        }

        setLoading(false)
    }

    useEffect(() => {
        if(!!code) handleSubmit()
    }, [code])

    return(
    <UI.Dialog size="xs" loading={loading} title="Código de segurança" {...props}>
        <DialogBody>
            <Stack gap={4}>
                <Text>Para esta ação, é necessário inserir o seu código de segurança.</Text>

                <UI.Show visible={!!user.data?.has_security_code}>
                    <Form.Pin autoFocus colorPalette="yellow" disabled={loading} onValueComplete={e => setCode(e.valueAsString)} />
                </UI.Show>

                <UI.Show visible={!user.data?.has_security_code}>
                    <UI.Alert indicator={<UI.Icon name="key" />} status="error" my={4} size="sm" title="Configure seu código de segurança">
                        O seu código de segurança (antiga senha financeira) é necessário para realizar algumas ações no seu escritório.
                    </UI.Alert>

                    <Button colorPalette="yellow" onClick={handleConfigure}><UI.Icon name="key" /> Configurar código de segurança</Button>
                </UI.Show>
            </Stack>
        </DialogBody>
    </UI.Dialog>
    )
}